import { expVal } from '@confluence/feature-experiments';

const eventName = 'forgePageBannerHeightUpdated';
const subscribers = new Set<() => void>();
let height = 0;

export const getForgePageBannerHeight = (): number => height;
export const getServerForgePageBannerHeight = (): number => 0;

// The banner observer writes this inline value before publishing its height event.
// Reading the inline style does not trigger computed-style or layout calculation.
const readInlineHeight = () =>
	typeof document !== 'undefined'
		? parseInt(document.documentElement.style.getPropertyValue('--forge-page-banner-height'), 10) ||
			0
		: 0;

const onHeightUpdated = (event: Event) => {
	const nextHeight = expVal('confluence_pgxp_p2m_batch_1', 'isEnabled', false)
		? ((event as CustomEvent<{ height?: number }>).detail?.height ?? 0)
		: readInlineHeight();

	if (height !== nextHeight) {
		height = nextHeight;
		subscribers.forEach((notify) => notify());
	}
};

// useSyncExternalStore subscribes after mounting, never during SSR or rendering.
export const subscribeToForgePageBannerHeight = (notify: () => void): (() => void) => {
	if (typeof document !== 'undefined') {
		if (subscribers.size === 0) {
			document.addEventListener(eventName, onHeightUpdated);
			// Pick up a measurement published before the first consumer mounted.
			height = readInlineHeight();
		}
		subscribers.add(notify);

		return () => {
			subscribers.delete(notify);
			if (subscribers.size === 0) {
				document.removeEventListener(eventName, onHeightUpdated);
				height = 0;
			}
		};
	}
	return () => {};
};

export const clearForgePageBannerHeightForTesting = (): void => {
	if (typeof document !== 'undefined') {
		document.removeEventListener(eventName, onHeightUpdated);
	}
	subscribers.clear();
	height = 0;
};
